import { ModusWcMenu } from '@trimble-oss/moduswebcomponents-react';
import { PropsWithChildren } from 'react';
import './Menu.scss';

type MenuProps = React.ComponentProps<typeof ModusWcMenu>;
export const Menu: React.FC<PropsWithChildren<MenuProps>> = ({ children, ...props }) => {
  return <ModusWcMenu {...props}>{children}</ModusWcMenu>;
};

export default Menu;
